export default {
    container: {
        height: "80vh",
        display: "flex",
        flexDirection: "column",
        p: 2,
    },
    stepper: {
        marginBottom: 2,
    },
    assetsContainer: {
        maxHeight: "calc(65vh - 300px)",
        overflowY: "auto",
        border: "1px solid #ccc",
        borderRadius: "8px",
        p: 1,
        "& .MuiGrid-item": {
            px: 2,
        },
    },
    navButtons: {
        my: 1,
        display: "flex",
        justifyContent: "space-between",
    },
    searchField: {
        marginBottom: "20px",
    },
    card: (isSelected) => ({
        cursor: "pointer",
        position: "relative",
        backgroundColor: isSelected ? "#d1e7dd" : "white",
        border: isSelected ? "2px solid #0f5132" : "1px solid #ccc",
        borderRadius: "8px",
        px: 5,
        py: 1,
        transition: "background-color 0.3s, border 0.3s",
        "& .MuiCardContent-root": {
            p: 0,
            paddingBottom: "0 !important",
        },
    }),
    checkbox: {
        position: "absolute",
        top: "-2px",
        left: "-2px",
        zIndex: 1,
        fontSize: "1rem",
    },
    pagination: {
        marginTop: "20px",
        display: "flex",
        justifyContent: "center",
    },
    stepsContainer: {
        maxHeight: "60vh",
        overflow: "scroll",
        padding: "8px",
    },
    chipContainer: {
        maxHeight: "30vh",
        overflow: "scroll",
        marginTop: "10px",
    },
    emptyMessage: {
        marginTop: "10px",
        color: "textSecondary",
    },
    exclusionReason: { width: "100%", paddingBottom: 2 },
};
/** TODO
 * Make colors with themes
 */
